/* ACCORDION */
function openAccordion(accordion) {
    var content = accordion.querySelector('.accordion__content');
    accordion.classList.add('accordion__active');
    content.style.maxHeight = content.scrollHeight + 'px';
}

function closeAccordion(accordion) {
    var content = accordion.querySelector('.accordion__content');
    accordion.classList.remove('accordion__active');
    content.style.maxHeight = null;
}
document.addEventListener('DOMContentLoaded', function () {
    var accordions = document.querySelectorAll('.accordion');

    accordions.forEach(function (accordion) {
        var handle = accordion.querySelector('.accordion__handle');
        var content = accordion.querySelector('.accordion__content');
        if (accordion.classList.contains('accordion__active')) openAccordion(accordion);
        handle.onclick = function () {
            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                accordions.forEach(function (accordion) {
                    return closeAccordion(accordion);
                });
                openAccordion(accordion);
            }
        };
    });
});

document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.style.setProperty('--scrollbar-width', window.innerWidth - document.documentElement.clientWidth + 'px');
});

function initProductImageCarousel(productId) {
    var viewport = document.querySelector('[data-product-item-id="' + productId + '"] .product-item__image-carousel');
    if (!viewport) return;

    window['__collection-product-item--' + productId + '--image-index'] = 0;
    var observer = new IntersectionObserver(
        function (entries, observer) {
            var activated = entries.reduce(function (max, entry) {
                return entry.intersectionRatio > max.intersectionRatio ? entry : max;
            });
            if (activated.intersectionRatio > 0) {
                var index = Array.from(viewport.children).findIndex(function (child) {
                    return child === activated.target;
                });
                if (index >= 0) window['__collection-product-item--' + productId + '--image-index'] = index;
            }
        },
        {
            root: viewport,
            threshold: 0.5
        }
    );
    for (var i = 0; i < viewport.children.length; i++) {
        observer.observe(viewport.children[i]);
    }

    var prevbtn = document.querySelector('[data-product-item-id="' + productId + '"] .product-item__image--arrow-prev');
    if (prevbtn) {
        prevbtn.addEventListener('click', function () {
            var newIndex = Math.max(0, window['__collection-product-item--' + productId + '--image-index'] - 1);
            viewport.children[newIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
    }

    var nextbtn = document.querySelector('[data-product-item-id="' + productId + '"] .product-item__image--arrow-next');
    if (nextbtn) {
        nextbtn.addEventListener('click', function () {
            var newIndex = Math.min(viewport.children.length - 1, window['__collection-product-item--' + productId + '--image-index'] + 1);
            viewport.children[newIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
    }

    viewport.scrollLeft = 0; // iOS fix
}
document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('[data-product-item-id] .product-item__image-carousel');
    carousels.forEach(function (carousel) {
        var product = carousel.closest('[data-product-item-id]');
        var productId = product.getAttribute('data-product-item-id');
        initProductImageCarousel(productId);
    });

    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    // more products are loaded in async (infinite scroll)
    var collection = document.querySelector('.collection-page__product-list');
    if (collection) {
        var collectionObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length <= 0) return;
                mutation.addedNodes.forEach(function (productEl) {
                    var carousel = productEl.querySelector('[data-product-item-id] .product-item__image-carousel');
                    if (!carousel) return;
                    var product = carousel.closest('[data-product-item-id]');
                    var productId = product.getAttribute('data-product-item-id');
                    initProductImageCarousel(productId);
                });
            });
        });
        collectionObserver.observe(collection, { childList: true, subtree: true });
    }


    // recommendations are loaded in async, we detect that and then init the carousels
    var wrapper = document.querySelector('.main__wrapper');
    if (wrapper) {
        var recomsObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                var section = mutation.target;
                if (!section.classList.contains('product-recommendations') || mutation.addedNodes.length <= 0) return;

                var recommendations = document.querySelectorAll('.product-recommendations [data-product-item-id] .product-item__image-carousel');
                recommendations.forEach(function (carousel) {
                    var product = carousel.closest('[data-product-item-id]');
                    var productId = product.getAttribute('data-product-item-id');
                    initProductImageCarousel(productId);
                });
            });
        });
        recomsObserver.observe(wrapper, { childList: true, subtree: true });
    }
});
